import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useMemo, useState, } from 'react';
import { useUtag } from 'Shared/hooks';
import { getViewUtagData } from 'Shared/utils';
import { Section, StaticTable } from 'Shared/components';
import { PageView } from 'Common/components/PageView/PageView';
import Header from 'Common/components/Header/Header';
import useStatistic from 'Common/hooks/useStatistic/useStatistic';
import { EPageName } from 'Common/types';
import { TEALIUM_EVENT } from 'Types/analytics';
import { ModelDefinitionsDataset } from 'ModelDefinitionsView/types';
import { MODEL_DEFINITIONS_DATASET_LOCAL_STORAGE_KEY } from 'ModelDefinitionsView/consts';
import { DatasetSelector, Description } from './components';
import { getColumns, getTableData } from './consts';
import styles from './Page.css';
const utagData = getViewUtagData({ tealiumEvent: TEALIUM_EVENT.MODEL_DEFINITIONS });
const Page = () => {
    const [selectedDataset, setSelectedDataset] = useState(() => {
        if (!FEATURE_FLAGS.PUBLIC_VERSION)
            return ModelDefinitionsDataset.DEFAULT;
        const storedValue = localStorage.getItem(MODEL_DEFINITIONS_DATASET_LOCAL_STORAGE_KEY);
        if (storedValue) {
            const storedValueParsed = JSON.parse(storedValue);
            if (storedValueParsed
                && Object.values(ModelDefinitionsDataset).includes(storedValueParsed)) {
                return storedValueParsed;
            }
        }
        return ModelDefinitionsDataset.DEFAULT;
    });
    const utag = useUtag();
    const columns = useMemo(() => getColumns(selectedDataset), [selectedDataset]);
    const data = useMemo(() => getTableData(selectedDataset), [selectedDataset]);
    useStatistic();
    useEffect(() => {
        utag.view(utagData);
    }, [utag]);
    return (_jsxs(PageView, Object.assign({ pageName: EPageName.ModelDefinitions }, { children: [_jsx(Header, {}, void 0), _jsxs(Section, Object.assign({ className: styles.section }, { children: [_jsx(Description, {}, void 0), FEATURE_FLAGS.PUBLIC_VERSION && (_jsx(DatasetSelector, { selectedDataset: selectedDataset, handleChange: setSelectedDataset }, void 0)), _jsx("div", { className: styles.divider }, void 0), _jsx(StaticTable, { columns: columns, data: data }, void 0)] }), void 0)] }), void 0));
};
export default memo(Page);
